import { useTranslation } from "react-i18next";
import { useNavigate } from "@tanstack/react-router";
import { ActionCard } from "~/components/card/action-card";
import { Text } from "~/components/text";
import { useOrganisation } from "~/contexts/organisation-provider";

export const OrganisationExportsPage = () => {
  const { t } = useTranslation("settings");
  const navigate = useNavigate();
  const { id: organisationId } = useOrganisation();

  return (
    <div className="space-y-6">
      <section>
        <Text as="h2" variant="pageHeading" className="mb-2">
          {t("organisation.exports.title")}
        </Text>
        <Text variant="subtle" className="pb-4">
          {t("organisation.exports.description")}
        </Text>

        <div className="space-y-4">
          <ActionCard
            title={t("organisation.exports.manual.title")}
            iconName="file-down"
            onClick={() =>
              navigate({
                to: "/settings/organisations/$organisationId/exports/manual",
                params: { organisationId },
              })
            }
          >
            <ActionCard.Action
              iconName="chevron-right"
              label={t("organisation.exports.manual.navigate")}
            />
          </ActionCard>
        </div>
      </section>
    </div>
  );
};
